import { lazy } from 'react';
const LazyVehicles = lazy(() => import('pages/private/vehicles'));
const LazyUsers = lazy(() => import('pages/private/users'));
const LazyOrganization = lazy(() => import('pages/private/organizations'));
const LazyAdminRoles = lazy(() => import('pages/private/administrator-roles'));
const LazyVehicleDetails = lazy(() => import('pages/private/vehicle-details'));
const LazyCompanies = lazy(() => import('pages/private/companies'));
const LazyProfile = lazy(() => import('pages/private/profile'));
const LazyWorkshopAppointments = lazy(() => import('pages/private/workshop-appointments'));
const LazySlotsAvailability = lazy(() => import('pages/private/slots-availability'));
const LazyAlerts = lazy(() => import('pages/private/alerts'));
const LazySatisfactionSurveys = lazy(() => import('pages/private/satisfaction-surveys'));
const LazySatisfactionSurveyDetails = lazy(
  () => import('pages/private/satisfaction-survey-details'),
);
const LazyVehicleConfiguration = lazy(() => import('pages/private/vehicle-config'));
const LazyMap = lazy(() => import('pages/private/maps'));
const LazyPayment = lazy(() => import('pages/private/payments'));
const LazyOfferAndTips = lazy(() => import('pages/private/offers-tips'));
const LazyWorkshopAppointmentDetails = lazy(() => import('pages/private/workshop-appointment-details'));
export const routes = [
  {
    id: 'VEHICLES',
    name: 'Vehicles',
    path: '/vehicles',
    element: <LazyVehicles />,
    type: 'DETAILS',
  },
  { id: 'USERS', name: 'Users', path: '/users', element: <LazyUsers /> },
  {
    id: 'ORGANIZATIONS',
    name: 'Organization',
    path: '/organizations',
    element: <LazyOrganization />,
  },
  {
    id: 'ADMINISTRATOR_ROLES',
    name: 'Administrator Roles',
    path: '/admin-roles',
    element: <LazyAdminRoles />,
  },
  {
    id: 'VEHICLE_DETAILS',
    name: 'Vehicle Details',
    path: '/vehicles/:vehicleId/*',
    element: <LazyVehicleDetails />,
  },
  {
    id: 'COMPANIES',
    name: 'Companies',
    path: '/companies',
    element: <LazyCompanies />,
  },
  {
    id: 'PROFILE',
    name: 'Profile',
    path: '/profile',
    element: <LazyProfile />,
  },
  {
    id: 'WORKSHOP_APPOINTMENTS',
    name: 'Workshop Appointments',
    path: '/workshop-appointments',
    element: <LazyWorkshopAppointments />,
  },
  {
    id: 'SLOTS_AVAILABILITY',
    name: 'Slots Availability',
    path: '/slot-availability/:id/slot-appointment',
    element: <LazySlotsAvailability />,
  },
  {
    id: 'ALERTS',
    name: 'Alerts',
    path: '/alerts/*',
    element: <LazyAlerts />,
  },
  {
    id: 'SATISFACTION_SURVEYS',
    name: 'Satisfaction Surveys',
    path: '/satisfaction-surveys/*',
    element: <LazySatisfactionSurveys />,
  },
  {
    id: 'SATISFACTION_SURVEY_DETAILS',
    name: 'Satisfaction Survey Details',
    path: '/satisfaction-surveys/survey-templates/:id/survey-details',
    element: <LazySatisfactionSurveyDetails />,
  },
  {
    id: 'VEHICLE_CONFIGURATION',
    name: 'Vehicle configurations',
    path: '/vehicle-config/*',
    element: <LazyVehicleConfiguration />,
  },
  {
    id: 'Map',
    name: 'Map',
    path: '/map',
    element: <LazyMap />,
  },
  {
    id: 'BILLING',
    name: 'Billing',
    path: '/payments',
    element: <LazyPayment />,
  },
  {
    id: 'OFFERS_AND_TIPS',
    name: 'Offers and Tips',
    path: 'offers-tips',
    element: <LazyOfferAndTips />,
  },
  {
    id: 'WORKSHOP_APPOINTMENT_DETAILS',
    name: 'Workshop appointment details',
    path: 'workshop-appointment/:waId',
    element: <LazyWorkshopAppointmentDetails />,
  },
];
